import React from 'react';
import classNames from 'classnames';
import {Avatar, Chip} from 'material-ui';

const SectionImages = ({images, onImageClick, onImageDelete, classes}) => {

    let imgs = [];
    if ( typeof images !== 'undefined' && images instanceof Array ) {
        imgs = images;
    } else {
        if (images) {
            imgs.push(images);
        }
    }

    return imgs.map((image, index) => {
        if (!image.deleted) {
            return (
                <Chip
                    onClick={() => onImageClick(image, index)}
                    avatar={<Avatar src={image.preview}/>}
                    className={classNames(classes.chip, 'deletable')}
                    onDelete={() => onImageDelete(image, index)}
                    key={index}
                    label={image.name}
                />
            );
        }
        return true;
    });
};

export default SectionImages;


// WEBPACK FOOTER //
// ./src/containers/builder/form/section_images.js